import React, { useState, useEffect } from 'react'

import { useHistory } from "react-router-dom";
import { Table, Tooltip,Tag, Input, Button, Space,message,Drawer,Modal,
  Statistic, Row, Col,Typography,List, Descriptions
} from 'antd';
import {   
    MenuUnfoldOutlined,
    MenuFoldOutlined,
    UserOutlined,
    VideoCameraOutlined,
    UploadOutlined, 
    DeploymentUnitOutlined,
    SearchOutlined
} from '@ant-design/icons';
import Highlighter from 'react-highlight-words';
import './styles.scss';

import { useDispatch, useSelector, shallowEqual } from 'react-redux'
import moment from 'moment'
import { Column } from '@ant-design/plots';
import MainPie from '../../analytics/MainPie'

import LineTime from '../../analytics/LineTime'
import ColumnTime from '../../analytics/ColumnTime'
import ColumnGroupTime from '../../analytics/ColumnGroupTime'
import ColumnStackedTime from '../../analytics/ColumnStackedTime'

import {numberWithCommas} from '../../../utils/helpers'

import {setWastableExrate} from '../../../Redux/actions/wastableActions'

import WasteditemExport from '../exports/wasteditemExport'

const { Title } = Typography;


const Index = ({maindata,datePickerValue, hideMoney = false}) => {

  const dispatch = useDispatch()   

  const { crudData,crudDataCount,locations,user,currentProps } = useSelector(
    state => ({
      user: state.auth.user,
      crudData: state.analytics.data,
      crudDataCount: state.analytics.dataCount,
      locations: state.locations.locations,
      currentProps: state.analytics.currentProps,
    }),
    shallowEqual
  )

    const [categorySold, setCategorySold] = useState([])
    const [productSold, setProductSold] = useState([])
    
    const [locationSold, setLocationSold] = useState([])

    const [allSold, setAllSold] = useState([])




    const [categoryFilter, setCategoryFilter] = useState({})
    const [selectedCategory, setSelectedCategory] = useState({})
    


    
    useEffect(() => {		
  
      if(locations && maindata && currentProps){

        if(currentProps.apiurl == "wastes"){
          console.log(maindata)
          getbranchTotals(maindata)
      
        }

      }
    }, [maindata,locations])



    useEffect(() => {		
        // console.log(selectedCategory)
        // console.log(categoryFilter)


    }, [categoryFilter,selectedCategory])



    const getbranchTotals =()=>{

      var locationProductCategories=[]  
      var new_locationProductCategories=[]  

  

      var allcats = []
      var allcatids = []

      var allprods = []
      var allprodids = []

      var allitems = []
      maindata.map(pk=>{

        if(pk.wasted_items ){ 
          pk.wasted_items.map(item=>{
         
            var newrprod={    
              branch:pk.branch,
              branch_name:pk.branch_name,
              sold_at:pk.created_at,  
              day_wasted: moment(pk.created_at).format('YYYY-MM-DD'),
              category:item.category,
              category_name:item.category_name,         
              product: item.key,
              product_name: item.name,              
              unit: item.unit,
              quantity: item.quantity,
              regionalization: item.regionalization,
              regionalization_name: item.regionalization_name
              
            }
            if(item.cost_peso){
              newrprod['item_cost'] = parseFloat(parseFloat(item.cost_peso) * parseFloat(item.quantity) )
            }
            if(item.cost_rmb){
              newrprod['item_cost'] = parseFloat(parseFloat(item.cost_rmb) * parseFloat(item.exchange_rate) * parseFloat(item.quantity))
            }

            if(!newrprod.item_cost){
              newrprod['item_cost'] = parseFloat(0)
            }


            allitems.push(newrprod) 


            if(!allprodids.includes(item.key)){
              allprodids.push(item.key)
              var newrprod={      
                category:item.category,
                category_name:item.category_name,         
                product: item.key,
                product_name: item.name,              
                unit: item.unit,            
                total_wasted:0,
                total_wasted_cost:0,
                regionalization: item.regionalization,
                regionalization_name: item.regionalization_name               
              }
              allprods.push(newrprod)
            }
            if(!allcatids.includes(item.category)){
              allcatids.push(item.category)
              var newcat={
                category:item.category,
                category_name:item.category_name,
         
              }
              allcats.push(newcat)
            }
          })
        }
      })

      locations.map(loc=>{   
        var cats = []
        var catids = []

        var prods = []
        var prodids = []

 
        
        maindata.map(pk=>{
          if(pk.wasted_items && pk.branch == loc.id ){
          pk.wasted_items.map(item=>{
            if(!catids.includes(item.category)){
              catids.push(item.category)
              var newcat={
                category:item.category,
                category_name:item.category_name,
            
              }
              cats.push(newcat)
            }
           
            if(!prodids.includes(item.key)){
              prodids.push(item.key)
              var newrprod={      
                category:item.category,
                category_name:item.category_name,         
                product: item.key,
                product_name: item.name,              
                unit: item.unit,
                quantity: item.quantity,
                total_wasted:0                  
              }
              prods.push(newrprod) 
       
            }
          })    
          }
            
        })

        var newlocprodcats ={
          categories: cats,
          products: prods,
          location: loc.id,
          loc_name:loc.name,
          commissary: loc.commissary,
        }
 
        locationProductCategories.push(newlocprodcats)        
      
      })   

      
      locationProductCategories.map(loc=>{
       
        var this_products = []
        var this_categories = []
        
        var this_product_total = 0
        var this_category_total = 0

        loc.products.map(prod=>{
          var prod_total =0
          var prod_total_cost =0
          var currentItem = null
          allitems.map(it=>{

            if(loc.location == it.branch && prod.product == it.product){
       
              prod_total += parseFloat(it.quantity)
              prod_total_cost += parseFloat(it.item_cost)
              currentItem = it
            }

          })
          var new_prod = {
            ...prod,
            total_wasted: prod_total,
            total_cost:prod_total_cost,
            regionalization: currentItem.regionalization,
            regionalization_name: currentItem.regionalization_name    
          }
          this_product_total += parseFloat(prod_total_cost)
          this_products.push(new_prod)

        })

        loc.categories.map(cat=>{
          var cat_total =0
          var cat_total_cost = 0
          allitems.map(it=>{
            if(loc.location == it.branch && cat.category == it.category){
              cat_total += parseFloat(it.quantity)
              cat_total_cost += parseFloat(it.item_cost)
            }

          })
          var new_cat = {
            ...cat,
            total_wasted: cat_total,
            total_cost:cat_total_cost
          }
          this_category_total += parseFloat(cat_total_cost)
          this_categories.push(new_cat)

        })

        var newlocprodcats ={
          categories: this_categories,
          category_total_cost: this_category_total,
          products: this_products,
          product_total_cost:this_product_total, 
          location: loc.location,
          loc_name:loc.loc_name,
          commissary: loc.commissary,

        }
        new_locationProductCategories.push(newlocprodcats)
      })

      var prod_sum = []
      var cat_sum = []



      allprodids.map(id=>{
        var prod_total =0
        var prod_total_cost =0

        var currentItem = null
        allitems.map(item=>{
       
          if(item.product == id ){
            prod_total += parseFloat(item.quantity)
            prod_total_cost += parseFloat(item.item_cost)

            currentItem = item
          }

        })
        var newrprod={      
          category:currentItem.category,
          category_name:currentItem.category_name,         
          product: currentItem.product,
          product_name: currentItem.product_name,              
          unit: currentItem.unit,  
          total_wasted:prod_total,
          total_cost: prod_total_cost,
          regionalization: currentItem.regionalization,
          regionalization_name: currentItem.regionalization_name          
        }
        prod_sum.push(newrprod)  
      })


      allcatids.map(id=>{
        var cat_total =0
        var cat_total_cost =0

        var currentItem = null
        allitems.map(item=>{
       
          if(item.category == id ){
            cat_total += parseFloat(item.quantity)
            cat_total_cost += parseFloat(item.item_cost)

            currentItem = item
          }

        })
        var newrprod={      
          category:currentItem.category,
          category_name:currentItem.category_name,                     
          total_wasted:cat_total,
          total_cost:cat_total_cost                
        }
        cat_sum.push(newrprod)  
      })



      // console.log(new_locationProductCategories)
      setLocationSold(new_locationProductCategories)
      // console.log(prod_sum)
      setProductSold(prod_sum)
      // console.log(cat_sum)
      setCategorySold(cat_sum)

      // console.log(allitems)
      
      setAllSold(allitems)

    }

    const renderProdcutsTable = (thisdata) =>{
      const columns = [
    
        {
          title: 'Category',
          dataIndex: 'category_name',
          defaultSortOrder: 'category_name',
          sorter: {
            compare: (a, b) => a.category_name.localeCompare(b.category_name), 
            multiple: 1    
          }, 
        },
            
        {
          title: 'Product',
          dataIndex: 'product_name',
          defaultSortOrder: 'product_name',
          sorter: {
            compare: (a, b) => a.product_name.localeCompare(b.product_name), 
            multiple: 1    
          }, 
        },              

        {
          title: 'Regionalization',
          dataIndex: 'regionalization',
          defaultSortOrder: 'regionalization',
          sorter: {
            compare: (a, b) => a.regionalization.localeCompare(b.regionalization), 
            multiple: 1    
          }, 
        },
            
        ...(!hideMoney
          ? [
              {
                title: 'Total (Php)',
                dataIndex: 'total_cost',
                defaultSortOrder: 'total_cost',
                sorter: (a, b) => a.total_cost - b.total_cost,
                sortDirections: ['descend', 'ascend'],
                render: (text, record, index) =>{ 
                  return(`${numberWithCommas(parseFloat(text).toFixed(2))}`)
                }
              },
            ]
          : []),    
        {
          title: 'Quantity',
          dataIndex: 'total_wasted',
          defaultSortOrder: 'total_wasted',
          sorter: (a, b) => a.total_wasted - b.total_wasted,
          sortDirections: ['descend', 'ascend'],
          render: (text, record, index) =>{ 
            return(`${numberWithCommas(parseFloat(text).toFixed(3))}`)
          }
        },
        {
          title: 'unit',
          dataIndex: 'unit',
          defaultSortOrder: 'unit',      
        },
  
      ];
      return(
        <Table columns={columns} dataSource={thisdata} size={'small'} className='thistable' 
          pagination={{
        
            pageSizeOptions:[25,50,100],
            defaultPageSize:25
 
          }}

          onRow={(record, rowIndex) => {
            return {
              onClick: event => {console.log(record)}, // click row
          
            };
        }}
        />
      )
    }

    const changeCategoryFilter = (e,loc) =>{
      var new_categoryFilter ={
        ...categoryFilter
      }
      new_categoryFilter[loc] = e
      setCategoryFilter(new_categoryFilter)
    }

    const changeSelectedCategory = (e,loc) =>{
      // var new_selectedCategory ={
      //   ...selectedCategory
      // }
      // new_selectedCategory[loc]=e
      setSelectedCategory(e)
    }

    const filteredthetable = (spending,loc)=>{

      if(selectedCategory){
        var ccat = selectedCategory
        var newspending = spending.filter(i => i.category == ccat.category)
        return(newspending)
      }else{

        return(spending)
      }
    } 

    
    const filterdatabybranch = (sold,loc)=>{
    
      var filsold = sold.filter(i => i.branch == loc)
      return(filsold)
      
    } 


    
    return(
      <div className='analytics_locations_container'> 
  
        <div>
         <Column
          data={allSold}
          isStack={true}
          xField={'day_wasted'}
          yField={hideMoney ? 'quantity' : 'item_cost'}
          seriesField={'branch_name'}
          tooltip={{
            formatter: (datum: Datum) => {
            
              return {
                name: datum.branch_name,
                value: hideMoney
                  ? ` ${datum.quantity ? numberWithCommas(parseFloat(datum.quantity).toFixed(2)) : 0}`
                  : `Php ${datum.item_cost ? numberWithCommas(parseFloat(datum.item_cost).toFixed(2)):0}`,
              };
            }
          }}
          label={{
            formatter: (v) => {},
            // 可手动配置 label 数据标签位置
            position: 'middle',
            // 'left', 'middle', 'right'
            // 可配置附加的布局方法
            layout: [
              // 柱形图数据标签位置自动调整
              {
                type: 'interval-adjust-position',
              }, // 数据标签防遮挡
              {
                type: 'interval-hide-overlap',
              }, // 数据标签文颜色自动调整
              {
                type: 'adjust-color',
              },
            ]
          }}
         />
        </div>
         
   
        <div className='mainoverall'>
          <div className='flex3 column'>
            <Title level={3} style={{marginTop:'1.5em' }}> 
            <div className='titlerow'>
              <span>Overall</span>   
              <div className='titlerow'>
              {selectedCategory ? 
                <Button onClick={()=>{changeSelectedCategory(null,'overall') }}>Reset Table</Button>
              :null}    
              <WasteditemExport values={productSold} datePickerValue={datePickerValue} name={'Overall'} hideMoney={hideMoney} />
              </div>     
            </div>
            </Title>
            {renderProdcutsTable(filteredthetable(productSold,'overall'))}
          </div>
          <div className='flex1 paddingpie column'>
            <MainPie  currentData={categorySold} 
                colorField={'category_name'}  angleField={hideMoney ? 'total_wasted' : 'total_cost'} 
                onSelectedCategories={(e)=>{changeCategoryFilter(e,'overall')}}
                onCurrentSelectedCategory={(e)=>{changeSelectedCategory(e,'overall')}}
            />
            {selectedCategory? 
            <MainPie  currentData={filteredthetable(productSold,'overall')} 
                colorField={'product_name'}  angleField={hideMoney ? 'total_wasted' : 'total_cost'} 
             
            />
            :null
            }
            {/* {selectedCategory['overall'] ? 
            <MainPie  currentData={filteredthetable(productSold,'overall')} 
                colorField={'product_name'}  angleField={'quantity'} 
             
            />
            :null
            } */}

              
      
          </div>    
       
        </div>  
        <Title level={3} style={{marginTop:'1.5em' }}>Locations</Title>
        <List
          itemLayout="vertical"
          size="large"
          pagination={false}
          dataSource={locationSold}
       
          renderItem={item => {
            // console.log(item.products)
            if(!item.commissary && item.products.length > 0){
            return(
            <List.Item
              key={item.loc_id}
              actions={[
                
              ]}
              extra={
                <div className='flex1 paddingpie column' >
                <MainPie  currentData={item.categories} 
                  colorField={'category_name'}  angleField={hideMoney ? 'total_wasted' : 'total_cost'} 
                  onSelectedCategories={(e)=>{changeCategoryFilter(e,item.location)}}
                  onCurrentSelectedCategory={(e)=>{changeSelectedCategory(e,item.location)}}
                />
                {selectedCategory? 
                <MainPie  currentData={filteredthetable(item.products,item.location)} 
                    colorField={'product_name'}  angleField={hideMoney ? 'total_wasted' : 'total_cost'} 
                 
                />
                :null
                }
     
                </div>
              }
            >
              <List.Item.Meta
                // avatar={<Avatar src={item.avatar} />}
                title={
                  <div className='titlerow'>
                    <span>{item.loc_name}</span>    
                    <div className='titlerow'>        
                    {selectedCategory? 
                      <Button onClick={()=>{changeSelectedCategory(null,item.location) }}>Reset Table</Button>
                    :null}  
                    <WasteditemExport values={item.products} datePickerValue={datePickerValue} name={item.loc_name} hideMoney={hideMoney}/>
                    </div>
                  </div>
                }
                description={
                  <div className='stats'>
                     <Descriptions size={'small'}>
                      {/* <Descriptions.Item label="Total Items">{`Php ${numberWithCommas(item.itemtotal.toFixed(2))}`}</Descriptions.Item>
                      <Descriptions.Item label="Total Shipping">{`Php ${numberWithCommas(item.shippingtotal.toFixed(2))}`}</Descriptions.Item>
                      <Descriptions.Item label="Total Spent">{`Php ${numberWithCommas((item.itemtotal + item.shippingtotal).toFixed(2))}`}</Descriptions.Item> */}
                    </Descriptions>
                  
                  </div>
                }
              />
              <Column
                data={filterdatabybranch(allSold,item.location )}
                isStack={true}
                xField={'day_wasted'}
                yField={hideMoney ? 'quantity' : 'item_cost'}
                seriesField={'category_name'}
                tooltip={{
                  formatter: (datum: Datum) => {
                  
                    return {
                      name: datum.category_name,
                      value: hideMoney
                        ? ` ${datum.quantity ? numberWithCommas(parseFloat(datum.quantity).toFixed(2)) : 0}`
                        : `Php ${datum.item_cost ? numberWithCommas(parseFloat(datum.item_cost).toFixed(2)):0}`,
                    };
                  }
                }}
                label={{
                  formatter: (v) => {},
                  // 可手动配置 label 数据标签位置
                  position: 'middle',
                  // 'left', 'middle', 'right'
                  // 可配置附加的布局方法
                  layout: [
                    // 柱形图数据标签位置自动调整
                    {
                      type: 'interval-adjust-position',
                    }, // 数据标签防遮挡
                    {
                      type: 'interval-hide-overlap',
                    }, // 数据标签文颜色自动调整
                    {
                      type: 'adjust-color',
                    },
                  ]
                }}
              />
                {renderProdcutsTable(filteredthetable(item.products, item.location))}
            </List.Item>
          )
          }}}

        />
    
      </div>
    )
}
  
export default Index
  
